export default "__VITE_PUBLIC_ASSET__be00ccb4__"